export enum ConnectOrganizationType {
    Bank = 'bank',
    SavingBank = 'savingBank',
    Card = 'card',
    Invest = 'invest',
    Insurance = 'insurance',
    GInsurance = 'ginsurance', // 보증보험
    Capital = 'capital',
    Telecom = 'telecom',
    Efin = 'efin',
}

export enum AssetConnectStatus {
    Connected = 'connected', // 내자산 연결된 자산 (간편결제계좌는 등록 됐을수도, 안됐을수도 있음)
    Disconnected = 'disconnected', // 내자산에 연결되지 않은 자산 (간편결제계좌만 등록한 자산)
}
